import { put, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import * as staffApi from '../api/staff-accounts.api';
import {
  cancelStaffInvitation,
  fetchStaffAccounts,
  inviteStaff,
  reinviteStaff,
  suspendStaff,
  unsuspendStaff,
} from './staff-accounts.slice';

const apiSaga = createPanelApiSaga();

/**
 * Personel hesabı sagaları. Invalidation ELLE ve AÇIK (`INVALIDATION_MAP`
 * `staffAccounts/*` → `staffAccountList`): beş mutasyonun her biri listeyi
 * sunucudan yeniden çeker.
 */
export function* staffAccountsSaga() {
  yield takeLatest(
    fetchStaffAccounts.request.type,
    apiSaga(fetchStaffAccounts, staffApi.fetchStaffAccounts),
  );

  yield takeLatest(
    inviteStaff.request.type,
    apiSaga(inviteStaff, staffApi.inviteStaff, {
      onSuccess: function* () {
        yield put(fetchStaffAccounts.request());
      },
    }),
  );

  yield takeLatest(
    reinviteStaff.request.type,
    apiSaga(reinviteStaff, (arg) => staffApi.reinviteStaff(arg.staffAccountId), {
      onSuccess: function* () {
        yield put(fetchStaffAccounts.request());
      },
    }),
  );

  yield takeLatest(
    cancelStaffInvitation.request.type,
    apiSaga(
      cancelStaffInvitation,
      async (arg) => {
        await staffApi.cancelStaffInvitation(arg.staffAccountId);
        return arg;
      },
      {
        onSuccess: function* () {
          yield put(fetchStaffAccounts.request());
        },
      },
    ),
  );

  yield takeLatest(
    suspendStaff.request.type,
    apiSaga(
      suspendStaff,
      async (arg) => {
        await staffApi.suspendStaff(arg.staffAccountId);
        return arg;
      },
      {
        onSuccess: function* () {
          yield put(fetchStaffAccounts.request());
        },
      },
    ),
  );

  yield takeLatest(
    unsuspendStaff.request.type,
    apiSaga(
      unsuspendStaff,
      async (arg) => {
        await staffApi.unsuspendStaff(arg.staffAccountId);
        return arg;
      },
      {
        onSuccess: function* () {
          yield put(fetchStaffAccounts.request());
        },
      },
    ),
  );
}
